import { AttachedPropertyValue, ComponentView } from "binder";
import { ButtonViewModel } from "./button-viewModel"

export class ButtonView extends ComponentView<ButtonViewModel>{
    GetViewUniqueId(): string {
        return "V-B64665D0-36B5-467C-8DEF-54580A06EB49" ;
    }
    loadHtml(): string {
        let element = require('./button.html').default;
        let style = require('./button.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;

    onClick(){
        this.dataContext.onClick();
    }
    onRenderCompleted(){
        this._childrenPlaceholder = this.firstlevelElement.querySelector('.V-B64665D0-36B5-467C-8DEF-54580A06EB49');
        // this._overlay = this.firstlevelElement.querySelector('.overlay');
    }
    private _childrenPlaceholder:Element;

    append(...nodes: (Node | string)[]): void{
        this._childrenPlaceholder.append(...nodes);
    }
}
